import { createGettext } from 'vue3-gettext';

export const availableLocales = ['en', 'fr'];
export const defaultLanguage = 'en';

const gettext = createGettext({
  availableLanguages: {
    en: 'English',
    fr: 'Français',
  },
  defaultLanguage,
  silent: true,
});

export default gettext;
